import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import toastr from "../../utils/toast";
import { decodeHtml } from "../../utils/decodeHtml";
import useSmartBack from "../../hooks/useSmartBack";
import InternalAllocation from "../../components/Modals/Roles/internalAllocation";
import UploadJDModal from "../../components/Modals/createjd/UploadJDModal";
import JDOptionsModal from "../../components/Modals/createjd/JDOptions";
import ProgressBar from "react-bootstrap/ProgressBar";
import {format_currency, currency_converter_inr} from "../../utils/currencyUtils";
import { Offcanvas } from "bootstrap";
import AddCompensation from "../../components/Modals/Roles/AddCompensation";
import ABAllocation from "../../components/Modals/Roles/A_BModel";
import AddMediaModal from "../../components/Modals/Roles/AddMediaModal";
import EditDescriptionModal from "../../components/Modals/Roles/EditDescriptionModal";
import AddOrder from "../../components/Modals/Orders/AddOrder";
import { formatDate } from "../../utils/format_dates";
import { Client_View } from "../../utils/sweetalert";
import { ReactTyped } from "react-typed";
import AssignedTo from "../../components/Modals/Roles/AssignedTo";
import ConvertToSearchModal from "../../components/Modals/Roles/ConvertToSearchModal";


function RoleDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const handleBack = useSmartBack("/role/list");
  const { token, setGlobalLoading } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
  const REACT_APP_BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;
  const [showJDOptions, setShowJDOptions] = useState(false);
  const [showUploadJDModal, setShowUploadJDModal] = useState(false);
  const [roleFiles, setRoleFiles] = useState([]);
  const [data, setData] = useState({ keywords: [] });
  const [workers, setworkers] = useState([]);
  const [internalAllocationModal, setInternalAllocationModal] = useState(false);
  const [closedCandidates, setClosedCandidates] = useState([]);
  const [addCompensationModal, setAddCompensationModal] = useState(false);
  const [rolecriterias, setRolecriterias] = useState([]);
  const [A_BModel, setA_BModel] = useState(false);
  const [abworker, setabworker] = useState([]);
  const [showAddMediaModal, setShowAddMediaModal] = useState(false);
  const [showEditDescriptionModal, setShowEditDescriptionModal] = useState(false);
  const [invoices, setinvoices] = useState([]);
  const [CandidateId, setCandidateId] = useState(null);
  const [CandidateInvoiceId, setCandidateInvoiceId] = useState(null);
  const [activities, setActivities] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [showAddOrderModal, setShowAddOrderModal] = useState(false);
  const handleFileDeleteClick = (fileId) => {confirmFileDelete(fileId, handleDeleteFile);};
  const [assignedToModal, setAssignedToModal] = useState(false);
  const [showConvertSearchModal, setShowConvertSearchModal] = useState(false);

  const generateAndDownloadJD = async () => {
    try {
      setGlobalLoading(true);

      const response = await axios.post(
        `${API_BASE_URL}/chatgpt/generate_jd`,
        { role_id: id },
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob", // important for file download
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `JD_${id}_${Date.now()}.docx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      fetchFiles();
      toastr.success("AI-generated JD saved and downloaded successfully!");
    } catch (error) {
      console.error("Error generating JD:", error);
      toastr.error("Failed to generate Job Description");
    } finally {
      setGlobalLoading(false);
    }
  };

  const fetch_detials = async () => {
    try {
      setGlobalLoading(true);
      const response = await fetch(`${API_BASE_URL}/roles/role_detail/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

    if (response.status === 403) {
      const errorData = await response.json();
      toastr.error(
        errorData.message || errorData.error || "You do not have permission to view this role"
      );
      navigate("/role/list");
      return;
    }

    if (!response.ok) {
      throw new Error("Failed to fetch role");
    }

      const data = await response.json();
      console.log("Role criterias:", data.rolecriterias);
      console.log("Role Details:", data.role_detail);
      data.role_detail = {
        ...data.role_detail,
        keywords: data.role_detail.keywords.split(","),
      };
      console.log("Role Details:", data.rolecriterias);

      setData(data.role_detail);
      setworkers(data.role_has_workers);
      const newData = data.compensation2?.length ? data.compensation2 : data.compensation1 || [];
      setClosedCandidates(newData);
      setRolecriterias(data.rolecriterias);
      setinvoices(data.invoices);
      setActivities(data.activities);
      console.log(data);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    fetch_detials();
    fetchFiles();
  }, [id]);

  const isProposal = data?.search_proposal == 1;

  const displayStatus = isProposal ? "Prospective" : data?.rolestatus;

  function formatTimestamp(ts) {
    const date = new Date(ts * 1000); // convert seconds → ms
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  }
  const fetchFiles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/roles/files/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRoleFiles(response.data.files || []);
    } catch (err) {
      console.error("Error fetching files:", err);
    }
  };
  const handleWorkerTargetChange = async (role_id, task_id) => {
    setGlobalLoading(true);
    try {
      const update = await axios.get(
        `${API_BASE_URL}/roles/worker_target_change/${role_id}/${task_id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      if (update.status == 200) {
        toastr.success(update.data.message);
        fetch_detials();
      }
    } catch (error) {
      if (error.status == 403) {
        toastr.error(error.response.data.message);
        fetch_detials();
      }
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const AddNewInternalAllocation = async () => {
    setInternalAllocationModal(true);
  };

  const ShowCompensation = (model_id) => {
    let name = `candidate_details${model_id}`;
    const myOffcanvas = document.getElementById(name);
    const bsOffcanvas = new Offcanvas(myOffcanvas);
    bsOffcanvas.show();
  };
  const confirmFileDelete = (fileId, onConfirmDelete) => {
    Client_View({
      title: "Are you sure?",
      text: "This file will be permanently deleted.",
      icon: "warning",
      confirmButtonText: "Yes, Delete",
      confirmCallback: () => onConfirmDelete(fileId),
      cancleCallback: () => {
        console.log("User cancelled deletion");
      },
    });
  };

  const handleDeleteFile = async (fileId) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/roles/delete_file/${fileId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      fetchFiles();
      toastr.error("File deleted successfully");
      fetch_detials(); // re-fetch files to refresh UI
    } catch (error) {
      console.error("Delete error:", error);
      toastr.error("Failed to delete file");
    }
  };

  const OpenAddOrderModal = (id, company_id) => {
    setSelectedRoleId(id);
    setSelectedCompanyId(company_id);
    setShowAddOrderModal(true);
  };

  const ChangeAssignedTo = async () => {
    setAssignedToModal(true);
  };

  return (
    <>
      <div className="content">
        <div className="row align-items-center mb-4">
          <div className="d-md-flex d-sm-block justify-content-between align-items-center flex-wrap">
            <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0"></h6>
            <div className="d-flex">
              <div className="d-flex flex-wrap gap-2">
                {(invoices.length === 0 || Number(data?.position_number) > invoices.length) && (
                  <button
                    className="btn btn-primary btn-sm d-inline-flex align-items-center"
                    onClick={() => OpenAddOrderModal(id, data.company_id)}
                  >
                    <i className="fa fa-money-bills me-1"></i> Add Order
                  </button>
                )}
                {showConvertSearchModal && (
                  <ConvertToSearchModal
                    onClose={() => setShowConvertSearchModal(false)}
                    roleData={data}
                    token={token}
                    refresh={fetch_detials}
                  />
                )}
                {showAddOrderModal && (
                  <AddOrder
                    onClose={() => {
                      setShowAddOrderModal(false);
                    }}
                    id={selectedRoleId}
                    companyId={selectedCompanyId}
                    token={token}
                  />
                )}
                {data?.search_proposal == 1 && (
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() =>
                      navigate(
                        `/role/add_new/${id}?mode=convert`,
                      )
                    }
                  >
                    Convert to Role
                  </button>
                )}
                <Link
                  to={`/workstation/view/${id}`}
                  className="btn btn-primary btn-sm d-inline-flex align-items-center"
                >
                  <i className="fa fa-users-between-lines me-1"></i> Workstation
                </Link>
                <Link
                  to={`/role/funnel/${id}`} state={{ returnTo: `/role/view/${id}` }}
                  className="btn btn-primary btn-sm d-inline-flex align-items-center"
                >
                  <i className="ti ti-chart-bar me-1"></i> Role Analysis
                </Link>
                <Link
                  to={`/role/sendRecommendedCandidate/${id}`}
                  className="btn btn-primary btn-sm d-inline-flex align-items-center"
                >
                  <i className="ti ti-robot me-1"></i> AI Candidates
                </Link>
                <Link
                  to={`/role/add_new/${id}`}
                  className="btn btn-primary btn-sm d-inline-flex align-items-center"
                >
                  <i className="ti ti-edit me-1"></i> Edit Role
                </Link>
                {data?.roletype === "Talent Scan" && (
                  <button
                    className="btn btn-warning btn-sm d-inline-flex align-items-center"
                    onClick={() => setShowConvertSearchModal(true)}
                  >
                    <i className="ti ti-refresh me-1"></i>
                    Convert to Search
                  </button>
                )}
                <button
                  className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
                  onClick={handleBack}
                >
                  <i className="ti ti-arrow-left me-2"></i>Back
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
            <div className="card">
              <div className="card-body">
                <h5 className="mb-3">Role Details</h5>
                <div className="list-group details-list-group mb-4">
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Role ID:</span>
                      <p className="text-gray-9">{data?.reference}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Job Location:</span>
                      <p className="text-gray-9">{`${data?.city || ""} ${
                        data?.city && data?.country_name
                          ? `(${data?.country_name})`
                          : `${data?.country_name}`
                      } `}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Positions:</span>
                      <p className="text-gray-9">{data?.position_number}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Regions:</span>
                      <p className="text-gray-9">{data?.region_name}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Role Type:</span>
                      <p className="text-gray-9">{data?.roletype}</p>
                    </div>
                  </div>
                  {data?.reportname && (
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Report Type:</span>
                        <p className="text-gray-9">{data?.reportname}</p>
                      </div>
                    </div>
                  )}
                  {data?.rolelevel && (
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Role Level:</span>
                        <p className="text-gray-9">{data?.rolelevel}</p>
                      </div>
                    </div>
                  )}
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Functions:</span>
                      <div className="d-flex align-items-center">
                        <p
                          className="text-gray-9 mb-0"
                          style={{ textAlign: "end" }}
                        >{`${data?.dutymaster} (${data?.duty})`}</p>
                      </div>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Industry:</span>
                      <div className="d-flex align-items-center">
                        <p
                          className="text-gray-9 mb-0"
                          style={{ textAlign: "end" }}
                        >{`${data?.industrymaster} (${data?.industry})`}</p>
                      </div>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Start Date:</span>
                      <div className="d-flex align-items-center">
                        <p className="text-gray-9 mb-0">
                          {data?.start || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Role Approval:</span>
                      <div className="d-flex align-items-center">
                        <p className="text-gray-9 mb-0">{`${
                          data?.approval_date ? `${data?.approval_date}` : "-"
                        }`}</p>
                      </div>
                    </div>
                  </div>
                  {data?.expected_compensation && (
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Expected Compensation:</span>
                        <div className="d-flex align-items-center">
                          <p className="text-gray-9 mb-0">
                            {data?.currency_symbol}{" "}
                            {format_currency(data?.expected_compensation)} (
                            {data?.curreny_name})
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Bill Type:</span>
                      <div className="d-flex align-items-center">
                        <p className="text-gray-9 mb-0">{data?.billtype}</p>
                      </div>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Dossier:</span>
                      <div className="d-flex align-items-center">
                        <p className="text-gray-9 mb-0">{data?.dossier}</p>
                      </div>
                    </div>
                  </div>
                  {data?.approvalby && (
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Approval by:</span>
                        <div className="d-flex align-items-center">
                          <p className="text-gray-9 mb-0">{data?.approvalby}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {data?.band && (
                    <div className="list-group-item">
                      <div className="d-flex align-items-center justify-content-between">
                        <span>Band/Title:</span>
                        <div className="d-flex align-items-center">
                          <p className="text-gray-9 mb-0">{data?.band}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="bg-light p-2 rounded">
                  <span className="d-block mb-1">Progress</span>
                  <div className="progress progress-md mb-2">
                    <ProgressBar
                      animated
                      max={100}
                      variant={data?.progress < 50 ? "danger" : "success"}
                      now={data?.progress}
                      label={`${data?.progress}%`}
                    />
                  </div>
                </div>
                <div className="custom-accordion-items">
                  <div className="accordion accordions-items-seperate">
                    {Array.isArray(rolecriterias) &&
                      rolecriterias.length > 0 && (
                        <div className="accordion-item flex-fill rounded mt-4">
                          <div className="accordion-header" id="headingTwo">
                            <div
                              className="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderTwo"
                              aria-expanded="false"
                              aria-controls="primaryBorderTwo"
                            >
                              <h5>Role Key Attributes</h5>
                              <div className=" ms-auto">
                                <a
                                  href="#"
                                  className="d-flex align-items-center collapsed collapse-arrow"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#primaryBorderTwo"
                                  aria-expanded="false"
                                  aria-controls="primaryBorderTwo"
                                >
                                  <i className="ti ti-chevron-down fs-18"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderTwo"
                            className="accordion-collapse collapse show border-top"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div className="list-group list-group-flush">
                                {rolecriterias.map((item, index) => (
                                  <div
                                    key={index}
                                    className="list-group-item border rounded mb-2 p-2"
                                  >
                                    <div className="row align-items-center row-gap-3">
                                      <div className="col-md-12">
                                        <div className="todo-inbox-check d-flex align-items-center row-gap-3">
                                          <span className="me-2 d-flex align-items-center rating-select">
                                            <i className="ti ti-star-filled filled"></i>
                                          </span>
                                          <div className="strike-info">
                                            <h4 className="fs-14">
                                              {item?.name}
                                            </h4>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                {activities.length > 0 && (
                  <>
                    <h5 className="mb-3 mt-3">Order Activity Logs</h5>
                    <div className="custom-accordion-items">
                      <div className="accordion accordions-items-seperate">
                        {activities.map((activity, index) => (
                          <div
                            key={index}
                            className="accordion-item flex-fill rounded"
                          >
                            <div
                              className="accordion-header collapsed"
                              id={`headingSix${index}`}
                              data-bs-toggle="collapse"
                              data-bs-target={`#primaryBorderSix${index}`}
                              aria-expanded="false"
                              aria-controls={`primaryBorderSix${index}`}
                            >
                              <div className="accordion-button">
                                <div className="d-flex align-items-center flex-fill">
                                  <h5>Order Id : {activity?.reference}</h5>
                                  <div className=" ms-auto d-flex align-items-center">
                                    <a
                                      href="#"
                                      className="d-flex align-items-center collapsed collapse-arrow"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#primaryBorderSix${index}`}
                                      aria-expanded="false"
                                      aria-controls={`primaryBorderSix${index}`}
                                    >
                                      <i className="ti ti-chevron-down fs-18"></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              id={`primaryBorderSix${index}`}
                              className="accordion-collapse collapse border-top"
                              aria-labelledby={`headingSix${index}`}
                            >
                              {activity?.items.map((item, index) => (
                                <div key={index} className="accordion-body">
                                  <span className="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                                    <i className="ti ti-file-description me-1"></i>
                                    {item?.name}
                                  </span>
                                  <div className="notice-widget">
                                    {item?.created_date && (
                                      <div className="d-flex align-items-center justify-content-between mb-4">
                                        <div className="d-flex overflow-hidden">
                                          <span className="bg-info avatar avatar-md me-3 rounded-circle flex-shrink-0">
                                            <i className="fa-solid fa-calendar-plus fs-16"></i>
                                          </span>
                                          <div className="overflow-hidden">
                                            <p className="text-truncate mb-1">
                                              <span className="text-gray-9 fw-medium">
                                                Created On
                                              </span>
                                            </p>
                                            <p className="mb-1">
                                              {formatDate(item?.created_date)}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {item?.raised_date && (
                                      <div className="d-flex align-items-center justify-content-between mb-4">
                                        <div className="d-flex overflow-hidden me-2">
                                          <span className="bg-warning avatar avatar-md me-3 rounded-circle flex-shrink-0">
                                            <i className="fa-solid fa-hand fs-16"></i>
                                          </span>
                                          <div className="overflow-hidden">
                                            <p className="text-truncate mb-1">
                                              <span className="text-gray-9 fw-medium">
                                                Raised On
                                              </span>
                                            </p>
                                            <p className="mb-1">
                                              {formatDate(item?.raised_date)}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {item?.issue_date && (
                                      <div className="d-flex align-items-center justify-content-between mb-4">
                                        <div className="d-flex overflow-hidden me-2">
                                          <span className="bg-purple avatar avatar-md me-3 rounded-circle flex-shrink-0">
                                            <i className="fa-solid fa-box-tissue fs-16"></i>
                                          </span>
                                          <div className="overflow-hidden">
                                            <p className="text-truncate mb-1">
                                              <span className="text-gray-9 fw-medium">
                                                Issued On
                                              </span>
                                            </p>
                                            <p className="mb-1">
                                              {item?.issue_date
                                                ? formatDate(item?.issue_date)
                                                : "Yet To Be Issued"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {item?.collection_date && (
                                      <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex overflow-hidden">
                                          <span className="bg-secondary avatar avatar-md me-3 rounded-circle flex-shrink-0">
                                            <i className="fa-solid fa-coins fs-16"></i>
                                          </span>
                                          <div className="overflow-hidden">
                                            <p className="text-truncate mb-1">
                                              <span className="text-gray-9 fw-medium">
                                                Collection On
                                              </span>
                                            </p>
                                            <p className="mb-1">
                                              {formatDate(
                                                item?.collection_date,
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="col-xxl-9 col-xl-8">
            <div className="card">
              <div className="card-body">
                <div className="bg-light rounded p-3 mb-3">
                  <div className="d-flex col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                      <div className="d-flex align-items-center">
                        <div>
                          <h6 className="mb-1">
                            <a href="javascript:void(0);">
                              {decodeHtml(data.name)}
                            </a>
                          </h6>
                          <p>
                            Client :{" "}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/client/view/${data.company_id}`,
                                )
                              }
                              className="text-primary"
                            >
                              {data.company_name}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                      style={{ textAlign: "end" }}
                    >
                      <div className="mb-4">
                        <span>
                          <i className="fa fa-calendar me-1"></i>{" "}
                          {formatTimestamp(data.datetime)}
                        </span>
                        {data?.expected_approx_fee && (
                          <div className="list-group-item">
                            <div className="d-flex align-items-center justify-content-sm-end">
                              <span className="me-2">Expected Approx Fee:</span>
                              <div className="d-flex align-items-center">
                                <p className="text-gray-9 mb-0">
                                  {data?.conversion_rate == 1
                                    ? data?.currency_symbol +
                                      ` ` +
                                      format_currency(data?.expected_approx_fee)
                                    : currency_converter_inr(
                                        data?.conversion_rate *
                                          data?.expected_approx_fee,
                                      ) +
                                      ` [${data?.currency_symbol}` +
                                      format_currency(
                                        data?.expected_approx_fee,
                                      ) +
                                      `]`}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row align-items-center">
                  <div className="col-sm-3">
                    <p className="d-flex align-items-center mb-3">
                      <i className="ti ti-square-rounded me-2"></i>Status
                    </p>
                  </div>
                  <div className="col-sm-9">
                    <span className="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                      <i className="ti ti-point-filled me-1"></i>
                      {displayStatus}
                    </span>
                  </div>
                  <div className="col-sm-3">
                    <p className="d-flex align-items-center mb-3">
                      <i className="ti ti-user-star me-2"></i>Role Manager
                    </p>
                  </div>
                  <div className="col-sm-9">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                        <a
                          href="javascript:void(0);"
                          className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                        >
                          <img
                            src={`${PINE_BASE_URL}/files/media/${data?.role_manager_pic}`}
                            alt="Img"
                          />
                        </a>
                        <h6 className="fs-12">
                          <a href="javascript:void(0);">{data?.role_manager}</a>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <p className="d-flex align-items-center mb-3">
                      <i className="ti ti-user-shield me-2"></i>Assigned To
                    </p>
                  </div>
                  <div className="col-sm-9">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                        <a
                          href="javascript:void(0);"
                          className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                        >
                          <img
                            src={`${PINE_BASE_URL}/files/media/${data?.assignedTo_pic}`}
                            alt="Img"
                          />
                        </a>
                        <h6 className="fs-12">
                          <a href="javascript:void(0);">{data?.assignedTo}</a>
                        </h6>
                      </div>
                      <a
                        href="javascript:void(0);"
                        onClick={() => ChangeAssignedTo()}
                        className="d-flex align-items-center fs-12"
                      >
                        <i className="ti ti-reload me-1"></i>Change
                      </a>
                      {assignedToModal && (
                        <AssignedTo
                          onClose={() => {
                            setAssignedToModal(false);
                            fetch_detials();
                          }}
                          roleId={data.id}
                          reference={data.reference}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <p className="d-flex align-items-center">
                      <i className="ti ti-users-group me-2"></i>Internal Team
                    </p>
                  </div>
                  <div className="col-sm-9">
                    <div
                      className="d-flex align-items-center mb-3"
                      style={{ flexWrap: "wrap" }}
                    >
                      {workers?.map((worker, index) => {
                        if (worker.ab == "0") {
                          return (
                            <div
                              className={`bg-gray-100 p-1 rounded d-flex align-items-center me-2 mb-1`}
                              key={index}
                              style={{
                                background: `${
                                  worker.user_status == "inactive"
                                    ? "#ff8e8e"
                                    : ""
                                }`,
                              }}
                            >
                              <a
                                href="javascript:void(0);"
                                className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                              >
                                <img
                                  src={`${PINE_BASE_URL}/files/media/${worker.userpic}`}
                                  alt="Img"
                                />
                              </a>
                              <h6 className="fs-12 d-flex">
                                <a
                                  className="mt-1"
                                  href="javascript:void(0);"
                                >{`${worker.firstname} ${worker.lastname}`}</a>
                                <button
                                  onClick={() =>
                                    handleWorkerTargetChange(data.id, worker.id)
                                  }
                                  title={`${
                                    worker.isconsultant == 1
                                      ? "Remove Target Allocation"
                                      : "Add Target Allocation"
                                  }`}
                                  className={`btn btn-icon ${
                                    worker.isconsultant == 1
                                      ? "btn-outline-success"
                                      : "btn-outline-danger"
                                  } rounded-pill my-icon ms-1`}
                                  disabled={
                                    worker.user_status == "inactive"
                                      ? true
                                      : false
                                  }
                                >
                                  <i
                                    className={`fa-solid ${
                                      worker.isconsultant == 1
                                        ? "fa-thumbs-up"
                                        : "fa-thumbs-down"
                                    }`}
                                  ></i>
                                </button>
                              </h6>
                            </div>
                          );
                        }
                      })}
                      <a
                        href="javascript:void(0);"
                        onClick={() => AddNewInternalAllocation()}
                        className="d-flex align-items-center fs-12"
                      >
                        <i className="ti ti-circle-plus me-1"></i>Add New
                      </a>
                      {internalAllocationModal && (
                        <InternalAllocation
                          onClose={() => {
                            setInternalAllocationModal(false);
                            fetch_detials();
                          }}
                          roleId={data.id}
                          reference={data.reference}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <p className="d-flex align-items-center mb-3">
                      <i className="fa-solid fa-user-graduate me-2"></i>A&B Team
                    </p>
                  </div>
                  <div className="col-md-9">
                    <div className="d-flex align-items-center mb-3">
                      {workers?.map((worker, index) => {
                        if (worker.ab == "1") {
                          return (
                            <div
                              className={`bg-gray-100 p-1 rounded d-flex align-items-center me-2 mb-1`}
                              key={index}
                              style={{
                                background: `${
                                  worker.user_status == "inactive"
                                    ? "#ff8e8e"
                                    : ""
                                }`,
                              }}
                            >
                              <a
                                href="javascript:void(0);"
                                className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                              >
                                <img
                                  src={`${PINE_BASE_URL}/files/media/${worker.userpic}`}
                                  alt="Img"
                                />
                              </a>
                              <h6 className="fs-12 d-flex">
                                <a
                                  className="mt-1"
                                  href="javascript:void(0);"
                                >{`${worker.firstname} ${worker.lastname}`}</a>
                                <button
                                  onClick={() =>
                                    handleWorkerTargetChange(data.id, worker.id)
                                  }
                                  title={`${
                                    worker.status == "active"
                                      ? "Disable User"
                                      : "Enable User"
                                  }`}
                                  className={`btn btn-icon ${
                                    worker.status == "active"
                                      ? "btn-outline-success"
                                      : "btn-outline-danger"
                                  } rounded-pill my-icon ms-1`}
                                >
                                  <i
                                    className={`fa-solid ${
                                      worker.status == "active"
                                        ? "fa-thumbs-up"
                                        : "fa-thumbs-down"
                                    }`}
                                  ></i>
                                </button>
                              </h6>
                            </div>
                          );
                        }
                      })}
                      <a
                        href="javascript:void(0);"
                        onClick={() => setA_BModel(true)}
                        className={`d-flex align-items-center fs-12 ${
                          workers?.some((worker) => worker.ab == "1")
                            ? "d-sm-none"
                            : ""
                        }`}
                      >
                        <i className="ti ti-circle-plus me-1"></i>Add New
                      </a>

                      {A_BModel && (
                        <ABAllocation
                          onClose={() => {
                            setA_BModel(false);
                            fetch_detials();
                          }}
                          roleId={data.id}
                          reference={data.reference}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <p className="d-flex align-items-center mb-3">
                      <i className="ti ti-bookmark me-2"></i>Tags
                    </p>
                  </div>
                  <div className="col-sm-9">
                    <div
                      className="d-flex align-items-center mb-3"
                      style={{ flexWrap: "wrap" }}
                    >
                      {Array.isArray(data?.keywords) &&
                        data.keywords.length > 0 &&
                        data.keywords.map((item, index) => (
                          <span
                            key={index}
                            className="badge badge-soft-primary d-inline-flex align-items-center me-2 mb-1"
                          >
                            <i className="ti ti-tag me-1"></i>
                            {item.trim()}
                          </span>
                        ))}
                    </div>
                  </div>
                  {closedCandidates.length > 0 &&
                    closedCandidates[0].candidate_id != null && (
                      <>
                        <div className="col-md-3">
                          <p className="d-flex align-items-center mb-3">
                            <i className="ti ti-clipboard me-2"></i> Closed Candidate
                          </p>
                        </div>
                        <div className="col-md-9 d-flex">
                          {closedCandidates.map((candidate, index) => (
                            <div className="d-flex align-items-center mb-3">
                              <div
                                key={index}
                                style={{ cursor: "pointer" }}
                                className="bg-gray-100 p-1 rounded d-flex align-items-center me-2"
                              >
                                <span
                                  onClick={() =>
                                    navigate(
                                      `/candidates/view/${candidate?.candidate_id}`,
                                    )
                                  }
                                >
                                  <h6 className="fs-12 d-flex align-items-center">
                                    <a
                                      href="javascript:void(0);"
                                      className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                                    >
                                      <img
                                        src={`${PINE_BASE_URL}/files/candidates/picture/${
                                          candidate?.candidate_userpic ||
                                          "no-pic.png"
                                        }`}
                                        alt="Img"
                                      />
                                    </a>
                                    <a href="javascript:void(0);">
                                      {candidate?.candidate_name}
                                    </a>
                                  </h6>
                                </span>
                                <i
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    ShowCompensation(candidate?.candidate_id)
                                  }
                                  className="fa-solid fa-comment-dollar fa-2x ms-sm-1"
                                ></i>
                              </div>
                            </div>
                          ))}
                        </div>
                        {closedCandidates.map((candidate, index) => (
                          <div
                            key={index}
                            className="offcanvas offcanvas-end offcanvas-large"
                            tabIndex="-1"
                            id={`candidate_details${candidate?.candidate_id}`}
                            style={{
                              maxHeight:
                                candidate?.comp_type == 2 ? "50vh" : "50vh",
                            }}
                          >
                            {addCompensationModal && (
                              <AddCompensation
                                onClose={() => {
                                  setAddCompensationModal(false);
                                  fetch_detials();
                                  setCandidateId(null);
                                  setCandidateInvoiceId(null);
                                }}
                                invoice_id={CandidateInvoiceId}
                                candidate_id={CandidateId}
                                roleId={data.id}
                              />
                            )}
                            <div className="offcanvas-header border-bottom">
                              <h4 className="d-flex align-items-center">
                                Candidate Details
                              </h4>
                              {candidate?.comp_type === 2 && (
                                <>
                                  <button
                                    onClick={() => {
                                      setAddCompensationModal(true);
                                      setCandidateId(candidate.candidate_id);
                                      setCandidateInvoiceId(
                                        candidate.invoice_id,
                                      );
                                    }}
                                    className="btn btn-warning fw-medium ms-2"
                                  >
                                    Add Compensation Breakup
                                  </button>
                                </>
                              )}

                              {candidate.comp_type == 1 && (
                                <button
                                  onClick={() => {
                                    setAddCompensationModal(true);
                                    setCandidateId(candidate.candidate_id);
                                    setCandidateInvoiceId(candidate.invoice_id);
                                  }}
                                  className="btn btn-warning fw-medium ms-2"
                                >
                                  Update Compensation
                                </button>
                              )}
                              <button
                                type="button"
                                className="btn-close custom-btn-close"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                              >
                                <i className="ti ti-x"></i>
                              </button>
                            </div>
                            <div className="offcanvas-body">
                              <div className="card">
                                <div className="card-body">
                                  <div className="d-flex align-items-center flex-wrap flex-md-nowrap row-gap-3">
                                    <span className="avatar avatar-xxxl candidate-img flex-shrink-0 me-3">
                                      <img
                                        src={`${PINE_BASE_URL}/files/candidates/picture/${
                                          candidate?.candidate_userpic ||
                                          "no-pic.png"
                                        }`}
                                        alt="Img"
                                      />
                                    </span>
                                    <div className="flex-fill border rounded p-3 pb-0">
                                      <div className="row align-items-center">
                                        <div className="col-md-4">
                                          <div className="mb-3">
                                            <p className="mb-1">
                                              Candiate Name
                                            </p>
                                            <h6 className="fw-normal">
                                              {candidate?.candidate_name}
                                            </h6>
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="mb-3">
                                            <p className="mb-1">DOJ</p>
                                            <h6 className="fw-normal">
                                              {candidate?.doj}
                                            </h6>
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <div className="mb-3">
                                            <p className="mb-1">
                                              Total Compensation
                                            </p>
                                            <h6 className="fw-normal">
                                              {`${
                                                candidate?.symbol
                                              } ${format_currency(
                                                candidate?.total_compensation,
                                              )}`}
                                            </h6>
                                          </div>
                                        </div>
                                        {candidate?.fixed && (
                                          <div className="col-md-3">
                                            <div className="mb-3">
                                              <p className="mb-1">Fixed</p>
                                              <h6 className="fw-normal">
                                                {candidate?.symbol}
                                                {format_currency(
                                                  candidate?.fixed,
                                                )}
                                              </h6>
                                            </div>
                                          </div>
                                        )}
                                        {candidate?.variable && (
                                          <div className="col-md-3">
                                            <div className="mb-3">
                                              <p className="mb-1">Variable</p>
                                              <h6 className="fw-normal">
                                                {candidate?.symbol}
                                                {format_currency(
                                                  candidate?.variable,
                                                )}
                                              </h6>
                                            </div>
                                          </div>
                                        )}
                                        {candidate?.others && (
                                          <div className="col-md-3">
                                            <div className="mb-3">
                                              <p className="mb-1">Others</p>
                                              <h6 className="fw-normal">
                                                {candidate?.symbol}
                                                {typeof candidate?.others ===
                                                "string"
                                                  ? candidate?.others
                                                  : format_currency(
                                                      candidate?.others,
                                                    )}
                                              </h6>
                                            </div>
                                          </div>
                                        )}
                                        {candidate?.savename && (
                                          <div className="col-md-3">
                                            <div className="mb-3">
                                              <p className="mb-1">Comp File</p>
                                              <h6 className="fw-normal">
                                                <a
                                                  target="_blank"
                                                  href={`${REACT_APP_BASE_URL_BACK}compensation_files/${candidate?.savename}`}
                                                >
                                                  View
                                                </a>
                                              </h6>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  <div className="col-sm-12">
                    <div className="mb-3">
                      <h6 className="mb-1 d-flex align-items-center gap-2">
                        Description
                        <i
                          className="fa-solid fa-pen text-primary"
                          onClick={() => setShowEditDescriptionModal(true)}
                          style={{ fontSize: "12px", cursor: "pointer" }}
                          title="Edit Description"
                        ></i>
                      </h6>
                      {data?.description ? (
                        <p>{data.description}</p>
                      ) : (
                        <div style={{ minHeight: "20px" }}>
                          <ReactTyped
                            strings={[
                              "Please tell us something about the role to help create a JD",
                            ]}
                            typeSpeed={60}
                            backSpeed={20}
                            loop={true}
                            showCursor={true}
                            className="text-muted fst-italic"
                          />
                        </div>
                      )}
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-sm d-inline-flex align-items-center"
                        style={{ backgroundColor: "#F37438", color: "white" }}
                        type="button"
                        onClick={() => setShowJDOptions(true)}
                      >
                        <i className="fa-solid  me-1"></i> Create/Upload JD
                      </button>

                      {showJDOptions && (
                        <JDOptionsModal
                          onClose={() => setShowJDOptions(false)}
                          onUpload={() => {
                            setShowJDOptions(false);
                            setShowUploadJDModal(true);
                          }}
                          onCreateAI={async () => {
                            setShowJDOptions(false);
                            await generateAndDownloadJD();
                          }}
                        />
                      )}

                      {showUploadJDModal && (
                        <UploadJDModal
                          roleId={id}
                          token={token}
                          onClose={() => setShowUploadJDModal(false)}
                          refresh={fetchFiles}
                        />
                      )}
                    </div>
                  </div>

                  <EditDescriptionModal
                    show={showEditDescriptionModal}
                    onClose={() => setShowEditDescriptionModal(false)}
                    roleId={id}
                    currentDescription={data?.description}
                    token={token}
                    refreshData={fetch_detials}
                  />
                </div>
              </div>
            </div>

            <div className="custom-accordion-items">
              <div className="accordion accordions-items-seperate">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingFour">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#primaryBorderFour"
                      aria-expanded="false"
                      aria-controls="primaryBorderFour"
                    >
                      <div className="d-flex align-items-center flex-fill">
                        <h5>Files</h5>
                        <div className=" ms-auto d-flex align-items-center">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => setShowAddMediaModal(true)}
                          >
                            Add Media
                          </button>

                          {/* Add Media Modal */}
                          {showAddMediaModal && (
                            <AddMediaModal
                              show={showAddMediaModal}
                              onClose={() => setShowAddMediaModal(false)}
                              roleId={id}
                              token={token}
                              refreshFiles={fetchFiles}
                            />
                          )}
                          <a
                            href="#"
                            className="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderFour"
                            aria-expanded="false"
                            aria-controls="primaryBorderFour"
                          >
                            <i className="ti ti-chevron-down fs-18"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderFour"
                    className="accordion-collapse collapse show border-top"
                    aria-labelledby="headingFour"
                  >
                    <div className="accordion-body">
                      <div className="files-carousel owl-carousel">
                        {roleFiles.length > 0 ? (
                          roleFiles.map((file) => (
                            <div
                              className="card shadow-none mb-0"
                              key={file.id}
                            >
                              <div className="card-body">
                                <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                                  <div className="d-flex flex-column">
                                    <h6 className="mb-1">{file.name}</h6>

                                    {/* <p className="text-muted small mb-0">
                                      Type ID: {file.documenttype_id}
                                    </p> */}
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <a
                                      href={`${REACT_APP_BASE_URL_BACK}jd_files/${file.savename}`}
                                      className="btn btn-sm btn-icon"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="ti ti-download"></i>
                                    </a>
                                    <button
                                      className="btn btn-sm btn-icon"
                                      onClick={() =>
                                        handleFileDeleteClick(file.id)
                                      }
                                    >
                                      <i className="ti ti-trash"></i>
                                    </button>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                  <p className="fw-medium mb-0">
                                    {new Date(file.date).toLocaleDateString(
                                      "en-GB",
                                    )}
                                  </p>
                                  <span className="text-muted small">
                                    Uploaded by: {file.uploaded_by}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p className="text-muted">No files uploaded yet.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <div
                    className="accordion-header"
                    id="headingSeven"
                    data-bs-toggle="collapse"
                    data-bs-target="#primaryBorderSeven"
                    aria-expanded="false"
                    aria-controls="primaryBorderSeven"
                  ></div>
                </div>

                <div className="accordion-item">
                  <div
                    className="accordion-header"
                    id="headingSeven"
                    data-bs-toggle="collapse"
                    data-bs-target="#primaryBorderSeven"
                    aria-expanded="false"
                    aria-controls="primaryBorderSeven"
                  >
                    <div className="accordion-button">
                      <h5>Invoices</h5>
                      <div className=" ms-auto d-flex align-items-center">
                        <a
                          href="#"
                          className="d-flex align-items-center collapsed collapse-arrow"
                          data-bs-toggle="collapse"
                          data-bs-target="#primaryBorderSeven"
                          aria-expanded="false"
                          aria-controls="primaryBorderSeven"
                        >
                          <i className="ti ti-chevron-down fs-18"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="primaryBorderSeven"
                    className="accordion-collapse collapse show border-top"
                    aria-labelledby="headingSeven"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="list-group list-group-flush">
                        {invoices.length > 0 &&
                          invoices.map((invoice) => (
                            <div
                              key={invoice.id}
                              className="list-group-item border rounded mb-2 p-2"
                            >
                              <div className="row align-items-center g-3">
                                <div className="col-sm-3">
                                  <div className="d-flex align-items-center">
                                    <span className="avatar avatar-lg bg-light flex-shrink-0 me-2">
                                      <i className="ti ti-file-invoice text-dark fs-24"></i>
                                    </span>
                                    <div>
                                      <h6 className="fw-medium mb-1 text-info">
                                        <span
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            navigate(
                                              `/order/view/${invoice.id}`,
                                            )
                                          }
                                          className="text-primary"
                                        >
                                          {invoice.reference}
                                        </span>
                                      </h6>
                                      <p>{formatTimestamp(invoice.datetime)}</p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-2">
                                  <div>
                                    <span>Total Fees</span>
                                    {invoice?.total_fees ? (
                                      <p className="text-dark">{`${
                                        invoice.symbol
                                      } ${format_currency(
                                        invoice.total_fees,
                                      )}`}</p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-sm-1">
                                  <div>
                                    <span>Fee %</span>
                                    {invoice?.fee_percentage ? (
                                      <p className="text-dark">{`${invoice.fee_percentage}`}</p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-sm-2">
                                  <div>
                                    <span>Total Comp</span>
                                    {invoice?.total_compensation ? (
                                      <p className="text-dark">{`${
                                        invoice.symbol
                                      } ${format_currency(
                                        invoice.total_compensation,
                                      )}`}</p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-sm-2">
                                  <div>
                                    <span>Billable Comp</span>
                                    {invoice?.billable_compensation ? (
                                      <p className="text-dark">{`${
                                        invoice.symbol
                                      } ${format_currency(
                                        invoice.billable_compensation,
                                      )}`}</p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-sm-2">
                                  <div>
                                    <span>Candidate</span>
                                    {invoice?.candidate_name ? (
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="bg-gray-100 p-1 rounded d-flex align-items-center me-2"
                                        onClick={() =>
                                          navigate(
                                            `/candidates/view/${invoice?.candidate_id}`,
                                          )
                                        }
                                      >
                                        <a
                                          href="javascript:void(0);"
                                          className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                                        >
                                          <img
                                            src={`${PINE_BASE_URL}/files/imageCandidate/${
                                              invoice?.candidate_userpic ||
                                              "no-pic.png"
                                            }`}
                                            alt="Img"
                                          />
                                        </a>
                                        <h6 className="fs-12">
                                          <a href="javascript:void(0);">
                                            {invoice?.candidate_name}
                                          </a>
                                        </h6>
                                      </div>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RoleDetail;
